import {type ContainerType, type AuthInfo} from '..';

export type CredentialsType = {
  init: () => void;
  getCreds: (timeoutMs?: number) => Promise<Creds>;
  setCreds: (value: Creds) => void;
};

type AuthInfoMinimal = {
  sessionId: string;
};
type UserCreds = {user: string; credentials: AuthInfo};
export type Creds = AuthInfoMinimal | AuthInfo | UserCreds;

export type UtilsType = {
  getContainer: () => ContainerType;
  numberWithCommas: (parameters: NumberWithCommasType) => string | 0;
};

export type NumberWithCommasType = {
  value: unknown;
  minimumFractionDigits: number;
  maximumFractionDigits?: number;
  defaultValue?: string | 0;
};
